/**
 * Generated bundle index. Do not edit.
 */

export {AnimationModule,Animation,AUTO_STYLE,AnimationGroupMetadata,AnimationKeyframesSequenceMetadata,AnimationSequenceMetadata,AnimationStateMetadata,AnimationStyleMetadata,AnimationTransitionMetadata,animate,group,keyframes,sequence,state,style,transition,AnimationTrigger,trigger} from './public_api';

export {resolveDefaultAnimationDriver as ɵa} from './src/animation_module';
export {AnimationMetadataType as ɵb} from './src/dsl/animation_metadata';
export {AnimationStyleNormalizer as ɵd} from './src/dsl/style_normalization/animation_style_normalizer';
export {WebAnimationsStyleNormalizer as ɵe} from './src/dsl/style_normalization/web_animations_style_normalizer';
export {AnimationDriver as ɵc} from './src/engine/animation_driver';
export {DomAnimationTransitionEngine as ɵg} from './src/engine/dom_animation_transition_engine';
export {TransitionEngine as ɵf} from './src/private_import_core';